import type { WebsiteBlock } from '../../types'
import { useBranding } from '../../contexts/BrandingContext'
import { useI18n } from '../../i18n'

interface ServicesProps {
  title: string
  titleEn?: string
  items: Array<{
    name: string
    nameEn?: string
    description: string
    descriptionEn?: string
    imageUrl?: string
    price?: string
  }>
}

export default function ServicesBlock({ block }: { block: WebsiteBlock }) {
  const { branding } = useBranding()
  const { lang } = useI18n()
  const p = block.props as ServicesProps

  const title = lang === 'en' && p.titleEn ? p.titleEn : p.title
  const hasContent = title?.trim() || (p.items && p.items.length > 0)
  if (!hasContent) return null

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        {title?.trim() && (
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 tracking-tight" style={{ color: branding.secondaryColor }}>
            {title}
          </h2>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {(p.items || []).map((item, i) => (
            <div key={i} className="group rounded-2xl bg-white border border-black/[0.04] overflow-hidden hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300">
              {item.imageUrl && (
                <div className="h-48 overflow-hidden">
                  <img src={item.imageUrl} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
              )}
              <div className="p-5">
                <h3 className="text-sm font-semibold mb-2" style={{ color: branding.secondaryColor }}>
                  {lang === 'en' && item.nameEn ? item.nameEn : item.name}
                </h3>
                <p className="text-xs text-gray-400 leading-relaxed">
                  {lang === 'en' && item.descriptionEn ? item.descriptionEn : item.description}
                </p>
                {item.price && (
                  <p className="mt-3 text-sm font-bold" style={{ color: branding.primaryColor }}>{item.price}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
